import { useState, FC, memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { translateError } from '~src/services/translationServices';
import { postImport } from '~src/services/fetch/import.service';
import PrimaryButtonLoading from '~src/shared/buttons/loadingButtons/PrimaryButtonLoading';

import { ErrorBox } from './integrationFileUpload.sc';
import { routes } from '~src/routingConfig';

interface OwnProps {
  integrationId: string;
  uploadError?: string;

  startImportStatusCheck(importId: string): void;
}

type Props = OwnProps;

interface Err {
  translation_key: string;
  arguments: object;
}

const IntegrationStartImport: FC<Props> = memo(props => {
  const [t] = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState([]);

  const uploadConfig = useMemo(
    () => ({
      headers: { Authorization: `Bearer ${localStorage.getItem('jwt')}` },
      data: { integration_id: props.integrationId },
    }),
    [props.integrationId],
  );
  const [importId, setImportId] = useState(null);
  const [statusCode, setStatusCode] = useState(null);
  const onclick = () => {
    setIsLoading(true);
    postImport(uploadConfig.data.integration_id)
      .then(rsp => {
        props.startImportStatusCheck(rsp.data.id);
       
      })
      .catch(rsp => {
        if (rsp.response.data) {
          const errorResponse = rsp.response.data as Array<Err>; 
          setStatusCode(rsp.response.status);
          setImportId(errorResponse[0].arguments.id);
          setErrors(errorResponse.map((item: Err) => translateError(t, item.translation_key)));
        }
      })
      .finally(() => setIsLoading(false));
  };

  const importLink = `${routes.company.importUsers}/${importId}`;

  return (
    <>
       {errors.length > 0 && <ErrorBox>{errors}</ErrorBox>}
       {props.uploadError && errors.length === 0 && <ErrorBox>{t(props.uploadError)}</ErrorBox>}
       {statusCode === 409 && (
        <a href={importLink} data-translation="x.company.import.cancel_running_import">{t('x.company.import.cancel_running_import')}</a>
       )}
       {!props.uploadError && errors.length === 0 && (
          <PrimaryButtonLoading
            data-translation="x.company.import.start_import_button"
            onClick={onclick}
            isLoading={isLoading}
         >
           {t('x.company.import.start_import_button')}
         </PrimaryButtonLoading>
      )}
    </>
  );
});

export default IntegrationStartImport;
